import { useState, useEffect } from 'react';
import './ClientStats.css';
import { getAllReviews, getAvgRating } from '../utils/reviewsStore';

export default function ClientStats() {
  const [avg, setAvg] = useState('4.9');

  useEffect(() => {
    const reviews = getAllReviews();
    setAvg(getAvgRating(reviews));
  }, []);

  const stats = [
    { value: '10+', label: 'Clients Served', icon: '◈', sub: 'Across India & globally' },
    { value: '10+', label: 'Projects Delivered', icon: '◈', sub: 'Web, AI & Research' },
    { value: '8+', label: 'Months Experience', icon: '◈', sub: 'Since 2025' },
    { value: avg + '★', label: 'Average Rating', icon: '◈', sub: 'Client satisfaction' },
  ];

  return (
    <div className="client-stats">
      <div className="container stats-inner">
        {stats.map(s => (
          <div key={s.label} className="stat-item">
            <div className="stat-icon">{s.icon}</div>
            <div className="stat-value">{s.value}</div>
            <div className="stat-label">{s.label}</div>
            <div className="stat-sub">{s.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
